import { render, staticRenderFns } from "./StatusAP.vue?vue&type=template&id=38848492&scoped=true"
import script from "./StatusAP.vue?vue&type=script&lang=js"
export * from "./StatusAP.vue?vue&type=script&lang=js"
import style0 from "./StatusAP.vue?vue&type=style&index=0&id=38848492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38848492",
  null
  
)

export default component.exports